// import axios from "axios";

let attempts = 0;
let fields = [
    "Child's Name",
    "School Code",
    "Grade",
]


var klaviyo_submit_btn;
var klaviyo_email_field;
var klaviyo_school_field;
var klaviyo_form_element;
var error_msg;
var validateSchoolInput = null;

// const getKlaviyoElements = (callback) => {
//     let all_fields_found = (klaviyo_email_field && klaviyo_form_element && klaviyo_submit_btn && klaviyo_school_field);

//     if ( !all_fields_found ) {
//         klaviyo_form_element = document.querySelector('#klaviyo-form');
//         klaviyo_email_field = klaviyo_form_element.querySelector("#email_address");
//         klaviyo_school_field = klaviyo_form_element.querySelector("#school_name");
//         klaviyo_submit_btn = klaviyo_form_element.querySelector("#klaviyosubmit");
        
//         all_fields_found = (klaviyo_email_field && klaviyo_form_element && klaviyo_submit_btn && klaviyo_school_field);
//     }
    
//     if ( !all_fields_found ) {
//         setTimeout(() => {
//             console.log("Could not find klaviyo fields", klaviyo_form_element,klaviyo_email_field,klaviyo_school_field,klaviyo_submit_btn);
//             getKlaviyoElements(callback);
//         }, 500);
//     } else {
//         if (callback) callback();
//     }
// }

const getKlaviyoElements = (callback) => {
  const form = document.querySelector('#klaviyo-form');
  if (!form) {
    setTimeout(() => getKlaviyoElements(callback), 500);
    return;
  }

  klaviyo_form_element = form;
  klaviyo_email_field = form.querySelector("#email_address");
  klaviyo_school_field = form.querySelector("#school_name");
  klaviyo_submit_btn = form.querySelector("#klaviyosubmit");

  const all_fields_found =
    klaviyo_email_field && klaviyo_school_field && klaviyo_submit_btn;

  if (!all_fields_found) {
    setTimeout(() => getKlaviyoElements(callback), 500);
    return;
  }

  if (callback) callback();
};


// const fillEmail = () => {
//     console.log('Filling email!')
//     klaviyo_email_field.value = window._L_SCEMAIL || ''
    
//     console.log('Email: ', klaviyo_email_field)
//     try {
//         let event = new Event('input', {
//             bubbles: true,
//             cancelable: true,
//         });
//         klaviyo_email_field.dispatchEvent(event);
//     } catch {
//         let event = document.createEvent('Event');
//         event.initEvent('input', true, true);

//         klaviyo_email_field.dispatchEvent(event);

//     }
//     if (klaviyo_email_field.value !== '') {
//         // klaviyo_email_field.style = 'pointer-events: none;';
//     }
// }

const fillEmail = () => {
  console.log('Filling email!');

  const fromShopify = (window._L_SCEMAIL || '').trim();
  const fromSession = (sessionStorage.getItem('register_email') || '').trim();

  // Prefer Shopify value, fallback to session
  const email = fromShopify || fromSession;

  // If we still have nothing, do nothing
  if (!email) return;

  // Don't overwrite if already filled (user typed)
  if (klaviyo_email_field.value && klaviyo_email_field.value.trim() !== '') return;

  klaviyo_email_field.value = email;

  // trigger Klaviyo listeners
  try {
    klaviyo_email_field.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    klaviyo_email_field.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  } catch {
    const e1 = document.createEvent('Event');
    e1.initEvent('input', true, true);
    klaviyo_email_field.dispatchEvent(e1);

    const e2 = document.createEvent('Event');
    e2.initEvent('change', true, true);
    klaviyo_email_field.dispatchEvent(e2);
  }

  console.log('Email set to:', email);
};



// var school_codes = [
//     'TAQS-0001',
//     'AHBS-0002',
//     'AALF-0003',
//     'AMBZ-0004',
//     'BSAK-0005',
//     'DESC-0006',
//     'DESS-0007',
//     'DGPS-0008',
//     'FGIS-0009',
//     'HLIS-0010',
//     'MWIS-0011',
//     'NBIS-0012',
//     'NAIS-0013',
//     'RHBS-0014',
//     'RGSG-0015',
//     'VHPS-0016',
//     'SISM-0017',
//     'TEC-0018',
//     'ACSAD-0019',
//     'SISAT-0020',
//     'SISAQ-0021',
//     'AAS-0022',
//     'AS-0023',
//     'DESS-0024',
//     'IAS-0025',
//     'DGPS-0026'
// ];

let school_codes = [];     // array of normalized codes
let school_codes_loaded = false;

const normalizeCode = (v) => String(v || '').trim().toUpperCase();

const fetchSchoolCodes = async () => {
  try {
    const res = await fetch('https://prod.trutex.ae/schools', {
      method: 'GET',
      headers: { 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' }
    });

    if (!res.ok) throw new Error(`Failed: ${res.status}`);

    const data = await res.json();

    // Accept multiple shapes:
    // 1) ["TAQS-0001", ...]
    // 2) { codes: [...] } or { data: [...] }
    // 3) { "TAQS-0001": "The Aquila School", ... }  -> keys are codes
    let codes = [];
    if (Array.isArray(data)) codes = data;
    else if (Array.isArray(data?.codes)) codes = data.codes;
    else if (Array.isArray(data?.data)) codes = data.data;
    else if (data && typeof data === 'object') codes = Object.keys(data);

    school_codes = codes.map(normalizeCode).filter(Boolean);
    school_codes_loaded = true;

    console.log('[school] loaded codes:', school_codes.length, school_codes.slice(0, 10));
  } catch (err) {
    school_codes_loaded = false;
    school_codes = [];
    console.error('[school] failed loading codes:', err);
  }
};



document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
getKlaviyoElements(async () => {
            fillEmail();
            error_msg = document.createElement('div');
            error_msg.classList.add('w-full');
            error_msg.style="color: #ee0000";
            klaviyo_submit_btn.parentElement.insertBefore(error_msg, klaviyo_submit_btn.nextSibling);
            error_msg.parentElement.classList.add('flex-wrap');

            // Start disabled until we load codes
            klaviyo_submit_btn.disabled = true;
            error_msg.innerHTML = 'Loading school codes...';
            klaviyo_school_field.setAttribute('aria-invalid', 'true');

            // Load codes once

validateSchoolInput = () => {
  const raw = klaviyo_school_field.value;

  // Don’t allow submit until codes loaded
  if (!school_codes_loaded) {
    error_msg.innerHTML = 'Loading school codes...';
    klaviyo_submit_btn.disabled = true;
    klaviyo_school_field.setAttribute('aria-invalid', 'true');
    return false;
  }

  const code = normalizeCode(raw);

  // Required field
  if (code === '') {
    error_msg.innerHTML = '';
    klaviyo_submit_btn.disabled = true;
    klaviyo_school_field.setAttribute('aria-invalid', 'true');
    return false;
  }

  const isValid = school_codes.includes(code);

  if (!isValid) {
    error_msg.innerHTML = "That's not a valid school code.";
    klaviyo_submit_btn.disabled = true;
    klaviyo_school_field.setAttribute('aria-invalid', 'true');
    return false;
  }

  // Normalize the input value
  klaviyo_school_field.value = code;

  error_msg.innerHTML = '';
  klaviyo_submit_btn.disabled = false;
  klaviyo_school_field.setAttribute('aria-invalid', 'false');
  return true;
};

// Load codes once
await fetchSchoolCodes();

// Validate whatever is in the field (if user typed fast)
validateSchoolInput();

            


klaviyo_school_field.addEventListener('input', validateSchoolInput);

            // klaviyo_school_field.addEventListener('input', function(event) {
            //     if (klaviyo_school_field.value === '') {
            //         error_msg.innerHTML = '';
            //         return;
            //     }
            //     let codes = klaviyo_school_field.value.split(',');
            //     let all_codes_valid = true;
            //     codes.forEach(code => {
            //         if (!school_codes.includes(code)) all_codes_valid = false;
            //     })
            //     if (!all_codes_valid ) {
            //         error_msg.innerHTML = "That's not a valid school code.";
            //         klaviyo_submit_btn.disabled = true;
            //     } 
            //     else {
            //         error_msg.innerHTML = '';
            //         klaviyo_submit_btn.disabled = false;
            //     }
            // });
        })
    }, 250);

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  if (!document.querySelector('#klaviyo-form')) return;

    document.querySelector('#klaviyo-form').addEventListener("submit", async function(e) { 
        e.preventDefault();
        // console.log("SUBMIT", e);
        // Disable the submit button
        document.querySelector("#klaviyosubmit").disabled = true;
        // Hard stop if invalid (prevents POST)
        if (!validateSchoolInput()) {
        document.querySelector("#klaviyosubmit").disabled = false;
        klaviyo_school_field.focus();
        return;
        }
            
        let payload = {
            customer_id: window._L_SCID,
            child_name: document.querySelector('#childs_name').value,
            school_name: document.querySelector('#school_name').value,
            school_grade: document.querySelector('#grade').value,
            email: document.querySelector('#email_address').value
        }

        console.log('Sending payload: ', payload)
    
        // const response  = await fetch('https://intimate-dominant-squirrel.ngrok-free.app/customers/assign', {
        const response  = await fetch('https://prod.trutex.ae/customers/assign', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'ngrok-skip-browser-warning': 'true' 
                },
            body: JSON.stringify(payload)
        });      

        console.log('Response data: ', response.data)
        
        if(response.ok){
            console.log('Success');
            sessionStorage.removeItem('register_email');
            window.location.href = '/pages/shop-by-school/'
        }else{
            // The form submission failed so re-enable the button
            document.querySelector("#klaviyosubmit").disabled = false;
            console.log('Error in sending info to Klaviyo.')
        }

        window.__klaviyo_data = payload;
        let button = document.getElementById('hidden-shop-now-button');
        button.classList.remove('hidden');
    });
});

